var _g, _g2, _g3, _text, _g4, _text2, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTailGateLiftTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 673 242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "TAILGATE"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    transform: "translate(-12.5 -45.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.1 185.4v-24.5",
    "data-name": "Line 79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.1 167.7V89a6.7 6.7 0 0 1 6.7-6.7h51.5a6.8 6.8 0 0 1 5.8 3.3l30.3 51.6a18.5 18.5 0 0 1 2.6 9.4v44.1a6.7 6.7 0 0 1-6.7 6.7h-33.6",
    "data-name": "Path 122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.1 185.4v4.7a6.018 6.018 0 0 0 6 6h7.5",
    "data-name": "Path 123"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 37",
    transform: "translate(470.6 171.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 38",
    transform: "translate(480.7 181.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 39",
    transform: "translate(253.9 171.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 40",
    transform: "translate(264 181.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 41",
    transform: "translate(186.8 171.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 42",
    transform: "translate(196.9 181.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.2 110.9h-33.4a6.7 6.7 0 0 0-6.7 6.7v13.5a6.7 6.7 0 0 0 6.7 6.7H552",
    "data-name": "Path 124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.3 184.2h161.8",
    "data-name": "Line 80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.8 184.2H256",
    "data-name": "Line 81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.1 89V63.3a6.7 6.7 0 0 0-6.7-6.7h-280a6.7 6.7 0 0 0-6.7 6.7v114.2a6.7 6.7 0 0 0 6.7 6.7H189",
    "data-name": "Path 125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.8 55 18.9 20.9",
    "data-name": "Line 82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.3 207.4 20.4-31a7.007 7.007 0 0 1 5.9-3.2h16.1",
    "data-name": "Path 126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.4 181.8h-14.6a4.067 4.067 0 0 0-3.5 1.9L132 207.4",
    "data-name": "Path 127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.8 215.3H48.6a2.433 2.433 0 0 1-2.4-2.4v-3.2a2.433 2.433 0 0 1 2.4-2.4h93.2a2.433 2.433 0 0 1 2.4 2.4v3.2a2.432 2.432 0 0 1-2.4 2.4Z",
    "data-name": "Path 128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.8 198.5h24.7",
    "data-name": "Line 83"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m165.4 58.9-56.1-10.7",
    "data-name": "Line 84"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M4.5 13.54v151.9",
    "data-name": "Line 85"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m0 14.84 4.5-7.7 4.5 7.7Z",
    "data-name": "Path 129"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m0 164.14 4.5 7.8 4.5-7.8Z",
    "data-name": "Path 130"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M11 191.84h114.2",
    "data-name": "Line 86"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m12.3 196.24-7.8-4.4 7.8-4.5Z",
    "data-name": "Path 131"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m123.9 196.24 7.7-4.4-7.7-4.5Z",
    "data-name": "Path 132"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M155.9 191.84h382.4",
    "data-name": "Line 87"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m157.2 196.24-7.8-4.4 7.8-4.5Z",
    "data-name": "Path 133"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m537 196.24 7.8-4.4-7.8-4.5Z",
    "data-name": "Path 134"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m559 181.44 35.6-62.4",
    "data-name": "Line 88"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m563.5 182.54-7.7 4.5-.1-9Z",
    "data-name": "Path 135"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m597.9 122.44-.1-9-7.7 4.5Z",
    "data-name": "Path 136"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 156"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 124",
    transform: "translate(-1131.532 -6487.347)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 33,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.798 6556.71a2 2 0 0 1 2.204-.8l20.574 5.853a2 2 0 0 1 .132 3.806l-32.568 11.848a2 2 0 0 1-2.344-3Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "H,H m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(28.135 76.416)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "H,H m")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-1128 -6334.428)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M59.861 201.065a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051H54.647a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 6"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    "data-name": "T,T m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(35.561 232.572)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "T,T m"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-852.092 -6334.428)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M335.769 201.065a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051h-13.828a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 6"
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    "data-name": "L,L m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(310.469 232.572)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "L,L m"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(-557.56 -6384.304)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.814 6547.788a2 2 0 0 1 .802 2.204l-5.854 20.574a2 2 0 0 1-3.806.132l-11.848-32.568a2 2 0 0 1 3-2.344Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "W,W m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(598.44 182.696)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "W,W m")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailGateLiftTruck);
export default __webpack_public_path__ + "static/media/TailGateLiftTruck.b860af23c3173707fa94e6f0d2a70315.svg";
export { ForwardRef as ReactComponent };